import React from "react";
import Button from "components/Form/fields/Button";
import { BUTTON_CLASS_CONTEXT, UI_THEME } from "utils/constants/ui";
import TemplateBuilderProgress from "../TemplateBuilderProgress";
import { useTemplateContinue } from "utils/formContext";

const DEFAULT_CLASSES = {
  container: "flex flex-column",
  actions: "flex flex-row justify-between pt3 ph3 mw-app"
};

const TemplateProgressControls = ({ onNext, tracking, customClasses } = {}) => {
  const classes = {
    ...DEFAULT_CLASSES,
    ...customClasses
  };

  const {
    isSubmitting,
    prevDisabled,
    prevCopy,
    prevAction,
    nextDisabled,
    nextCopy,
    nextAction
  } = useTemplateContinue({ onNext, tracking });

  return (
    <div className={classes.container}>
      <TemplateBuilderProgress />
      <div className={classes.actions}>
        <Button
          classes={{
            contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
          }}
          theme={UI_THEME.SLIM}
          disabled={prevDisabled}
          copy={prevCopy}
          onClick={prevAction}
        />
        <Button
          theme={UI_THEME.SLIM}
          copy={nextCopy}
          disabled={nextDisabled}
          loading={isSubmitting}
          onClick={nextAction}
        />
      </div>
    </div>
  );
};

export default TemplateProgressControls;
